import { pageFactory } from "./factory";
import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { reset_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/reset_template";
export class reset_password extends vnModule_knockoutJS {
    getModuleName() {
        return "reset_password";
    }
    buildContent() {
        let resetTemplate = new reset_template("resetTemplate", this.viewModel, this);
        return [resetTemplate.build()];
    }
    fillPage() {
        this.validateToken();
    }
    validateToken() {
        let token;
        let action;
        if (token = this.getVnAppZone().app.params.token) {
            let validateReq_url = '/api/access/validate/token/' + token + '/';
            let validateReq_params = [];
            // validateReq_params.push(["data", JSON.stringify({"token":token})] );
            this.XHRHdl = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);
            this.XHRHdl.onReadyStateFunction = this.showValidateTemplate;
            this.XHRHdl.execute();
        }
    }
    showValidateTemplate(req, obj) {
        return function () {
            if (req.request.readyState == 4) {
                let thisModule = obj;
                if (req.request.status == 200) {
                    obj.viewModel["resetTemplate"].validateToken("block");
                }
                else {
                    obj.viewModel["resetTemplate"].invalidateToken("block");
                }
            }
        };
    }
    retrievePassword() {
        let _this = this;
        let loginReq_url = '/api/access/retrievepassword/';
        let loginReq_Params = [];
        loginReq_Params.push(["data", ko.toJSON(this.viewModel["resetTemplate"])]);
        let XHRHdl = new XMLHttpRequestHandler(loginReq_url, loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.readyState == 4) {
                    let responseParsed = JSON.parse(req.request.response);
                    //let actualpageCtrl = (<login>obj);
                    if (req.request.status == 200) {
                        //let factory = new pageFactory;
                        if (responseParsed.data) {
                            // GET OBJECT OF THE RIGHT PAGE
                            //page.redirect('/home');
                            document.querySelector("#retrieve-password").setAttribute("style", "display: none;");
                            obj.viewModel["resetTemplate"].sentMessage("block");
                            obj.viewModel["resetTemplate"].retrieveInfo(responseParsed.data);
                        }
                    }
                    else {
                        document.querySelector("#retrieve-password").setAttribute("style", "display: none;");
                        obj.viewModel["resetTemplate"].sentMessage("block");
                        obj.viewModel["resetTemplate"].retrieveInfo(responseParsed.message);
                    }
                }
            };
        });
        XHRHdl.execute();
    }
    redirectToLogin() {
        page.redirect('/login');
    }
    resetPassword() {
        let _this = this;
        let token;
        let loginReq_url = '/api/access/resetpassword/';
        let loginReq_Params = [];
        if (token = this.getVnAppZone().app.params.token) {
            this.viewModel["resetTemplate"].token(token);
        }
        loginReq_Params.push(["data", ko.toJSON(this.viewModel["resetTemplate"])]);
        let XHRHdl = new XMLHttpRequestHandler(loginReq_url, loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.readyState == 4) {
                    let responseParsed = JSON.parse(req.request.response);
                    //let actualpageCtrl = (<login>obj);
                    if (req.request.status == 200) {
                        //let factory = new pageFactory;
                        // GET OBJECT OF THE RIGHT PAGE
                        //page.redirect('/home');
                        document.querySelector("#reset-password-form").setAttribute("style", "display: none;");
                        obj.viewModel["resetTemplate"].sentMessage("block");
                        obj.viewModel["resetTemplate"].retrieveInfo(responseParsed.data);
                    }
                    else {
                        _this.resetFormFieldsNotifications();
                        _this.renderNotifications(responseParsed.message);
                    }
                }
            };
        });
        XHRHdl.execute();
    }
    renderNotifications(errorMessage) {
        let errorField = document.querySelector("small");
        if (errorField !== null) {
            errorField.classList.add('is-error');
            errorField.innerHTML = errorMessage;
        }
    }
    resetFormFieldNotifications(field) {
        if (field.classList.contains('is-error')) {
            field.classList.remove('is-error');
            field.innerHTML = '';
        }
    }
    resetFormFieldsNotifications() {
        let fields = document.querySelectorAll("small");
        for (let field of fields) {
            this.resetFormFieldNotifications(field);
        }
    }
}
